import React from "react";
import { useTranslation } from "react-i18next";

import { StyledSelect } from "../../organisms/Menus/FilterMenu/FilterMenuStyles";
import { dropDownCategoryOpts } from "../../../constants/categories";
import { IColumnProps } from "../../../interfaces/tables";

interface Props {
  column: IColumnProps<{}>;
}

const CategoryFilter: React.FC<Props> = ({ column: { setFilter } }) => {
  const { t } = useTranslation();
  return (
    <StyledSelect
      placeholder={t("Filter.Category")}
      fluid
      search
      selection
      multiple
      options={dropDownCategoryOpts}
      onChange={(e: any, data: any) => setFilter(data.value)}
    />
  );
};

export default CategoryFilter;
